import { Box, Text } from "grommet";
export function Page404() {
  return (
    <Box fill  align="center" justify="center">      
      <Text size="xxlarge">404 :( </Text>
    </Box>
  );
}
